import { useTranslation } from "react-i18next";
import { Checkbox } from "src/primitives/Checkbox";

interface SelectionCheckboxProps {
  checked: boolean | "indeterminate";
  onCheckedChange: (checked: boolean) => void;
  ariaLabel?: string;
}

export const SelectionCheckbox = ({
  checked,
  onCheckedChange,
  ariaLabel,
}: SelectionCheckboxProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center justify-center">
      <Checkbox
        checked={checked}
        onCheckedChange={onCheckedChange}
        aria-label={
          ariaLabel ?? t("neetoatoms.dataTable.selectRow", "Select row")
        }
      />
    </div>
  );
};
